import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import Calendar, { CalendarProps } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './DateFilter.scss';

interface DateFilterProps {
  startDate: string;
  setStartDate: (startDate: string) => void;
  endDate: string;
  setEndDate: (endDate: string) => void;
  soloSesionActual?: boolean;
}

const DateFilter: React.FC<DateFilterProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  soloSesionActual = false
}) => {
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);

  // Convierte el string a Date o null (soporta YYYY-MM-DD y YYYY-MM-DDTHH:mm:ss)
  const parseDateString = (str: string) => {
    if (!str) return null;
    // Si ya tiene hora, pásalo directo
    if (str.includes('T')) return new Date(str);
    // Si no, agrégale T00:00:00
    return new Date(`${str}T00:00:00`);
  };
  const startDateObj = parseDateString(startDate);
  const endDateObj = parseDateString(endDate);

  // Formatea para mostrar al usuario (DD-MM-YYYY)
  const formatDisplayDate = (date: Date): string => {
    const year  = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day   = date.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  };

  // Formatea para guardar en el estado (YYYY-MM-DD)
  const formatStateDate = (date: Date): string => {
    const year  = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day   = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleStartDateChange: CalendarProps['onChange'] = (value) => {
    const date = Array.isArray(value) ? value[0] : value;
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const formatted = formatStateDate(localDate);
      setStartDate(formatted);
    }
    setShowStartCalendar(false);
  };

  const handleEndDateChange: CalendarProps['onChange'] = (value) => {
    const date = Array.isArray(value) ? value[0] : value;
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const formatted = formatStateDate(localDate);
      setEndDate(formatted);
    }
    setShowEndCalendar(false);
  };

  return (
    <div className="receipt-date-filter-container">
      <div className="date-filter">
        <Form.Group controlId="startDate" className='mp-formgroup horizontal offcanvas'>
          <Form.Label>Fecha Inicio</Form.Label>
          <Button
            variant="none"
            onClick={() => setShowStartCalendar(!showStartCalendar)}
            className="boton-show-calendar-offcanvas"
            disabled={soloSesionActual}
          >
            {showStartCalendar
              ? 'Ocultar'
              : startDateObj
                ? formatDisplayDate(startDateObj)
                : 'Seleccionar fecha'}
          </Button>
        </Form.Group>
        {showStartCalendar && (
          <div className='mp-form-calendar-container'>
            <Calendar
              onChange={handleStartDateChange}
              value={startDateObj || new Date()}
              locale="es-ES"
              className="mp-form-calendar"
            />
          </div>
        )}
      </div>

      <div className="date-filter">
        <Form.Group controlId="endDate" className='mp-formgroup horizontal offcanvas'>
          <Form.Label>Fecha Fin</Form.Label>
          <Button
            variant="none"
            onClick={() => setShowEndCalendar(!showEndCalendar)}
            className="boton-show-calendar-offcanvas"
            disabled={soloSesionActual}
          >
            {showEndCalendar
              ? 'Ocultar'
              : endDateObj
                ? formatDisplayDate(endDateObj)
                : 'Seleccionar fecha'}
          </Button>
        </Form.Group>
        {showEndCalendar && (
          <div className='mp-form-calendar-container'>
            <Calendar
              onChange={handleEndDateChange}
              value={endDateObj || new Date()}
              locale="es-ES"
              className="mp-form-calendar"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateFilter;